@switch (reply.phase) {
  @case ('thinking') {
    <div class="thomas-status">
      <span>{{ message.text }}</span>
      <span class="thomas-typing"><span></span><span></span><span></span></span>
    </div>
  }
  @case ('error') {
    <div class="thomas-error">
      <i class="material-icons">error_outline</i>
      <span>{{ message.text }}</span>
    </div>
  }
  @default {
    <div class="thomas-text" [innerHTML]="html"></div>

    @if (reply.phase === 'streaming') {
      <span class="thomas-typing"><span></span><span></span><span></span></span>
    } @else {
      @for (card of reply.cards; track card) {
        <ng-container *ngComponentOutlet="card.component; inputs: card.inputs"></ng-container>
      }

      @if (reply.responseId) {
        <div class="thomas-feedback">
          <div class="thomas-feedback-buttons">
            <button type="button" class="thomas-feedback-button" title="Helpful" aria-label="Helpful"
              [attr.aria-pressed]="reply.feedback.selection === true"
              [class.selected]="reply.feedback.selection === true" [disabled]="reply.feedback.submitting"
              (click)="thomas.selectFeedback(reply, true)">
              <i class="material-icons">thumb_up</i>
            </button>
            <button type="button" class="thomas-feedback-button" title="Not helpful" aria-label="Not helpful"
              [attr.aria-pressed]="reply.feedback.selection === false"
              [class.selected]="reply.feedback.selection === false" [disabled]="reply.feedback.submitting"
              (click)="thomas.selectFeedback(reply, false)">
              <i class="material-icons">thumb_down</i>
            </button>
            @if (reply.feedback.submitted && !reply.feedback.editing) {
              <span class="thomas-feedback-thanks">Thanks for the feedback</span>
              <button type="button" class="thomas-link-button" (click)="thomas.editFeedback(reply)">Edit</button>
            }
          </div>

          @if (showFeedbackForm) {
            <div class="thomas-feedback-form">
              <textarea rows="2" maxlength="2000" placeholder="Tell us more (optional)" aria-label="Feedback comment (optional)"
                [(ngModel)]="reply.feedback.comment" [disabled]="reply.feedback.submitting"></textarea>
            </div>
            <div class="thomas-feedback-actions">
              <button type="button" class="thomas-button-quiet" [disabled]="reply.feedback.submitting"
                (click)="thomas.cancelFeedback(reply)">Cancel</button>
              <button type="button" class="thomas-button-primary small" [disabled]="reply.feedback.submitting"
                (click)="thomas.submitFeedback(reply)">
                {{ reply.feedback.submitting ? 'Sending...' : (reply.feedback.submitted ? 'Update' : 'Send') }}
              </button>
            </div>
          }
        </div>
      }
    }
  }
}
